module.exports = {"id":"206591","name":"Mitchell Weiser","rating":"78","photo":"./data/images/photos/0/206591.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["DD","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MitchellWeiser0.json
// module id = 3057
// module chunks = 0